import { useState } from "react";

const insights = [
  {
    id: 1,
    type: "risk",
    icon: "ri-error-warning-line",
    color: "text-red-500",
    bg: "bg-red-50",
    border: "border-red-100",
    title: "欠费风险预警",
    desc: "AI识别到 23 户用户连续3个月用气量下降超50%，结合历史缴费记录，预测欠费概率 &gt;78%",
    action: "查看名单",
    tag: "高风险",
    tagColor: "bg-red-100 text-red-600",
  },
  {
    id: 2,
    type: "anomaly",
    icon: "ri-pulse-line",
    color: "text-amber-500",
    bg: "bg-amber-50",
    border: "border-amber-100",
    title: "用气异常检测",
    desc: "AI检测到 8 户用户本月用气量较同期增长超200%，可能存在设备泄漏或计量异常，建议立即核查",
    action: "立即核查",
    tag: "需关注",
    tagColor: "bg-amber-100 text-amber-600",
  },
  {
    id: 3,
    type: "recommend",
    icon: "ri-robot-2-line",
    color: "text-teal-500",
    bg: "bg-teal-50",
    border: "border-teal-100",
    title: "套餐推荐优化",
    desc: "基于用气行为分析，156 户居民用户适合升级至阶梯优惠套餐，预计可提升营收 ¥12,400/月",
    action: "批量推送",
    tag: "增收机会",
    tagColor: "bg-teal-100 text-teal-600",
  },
  {
    id: 4,
    type: "safety",
    icon: "ri-shield-check-line",
    color: "text-orange-500",
    bg: "bg-orange-50",
    border: "border-orange-100",
    title: "安检到期提醒",
    desc: "AI预测 41 户用户安检证书将在30天内到期，其中 12 户已超期，建议优先安排上门安检",
    action: "安排安检",
    tag: "待处理",
    tagColor: "bg-orange-100 text-orange-600",
  },
];

export default function ResidentAIInsight() {
  const [expanded, setExpanded] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [reportReady, setReportReady] = useState(false);

  const handleGenReport = () => {
    setGenerating(true);
    setTimeout(() => {
      setGenerating(false);
      setReportReady(true);
    }, 2200);
  };

  return (
    <div className="bg-gradient-to-r from-[#0f1729] to-[#1a2540] rounded-xl p-4 border border-white/10">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#E8531A]/20">
            <i className="ri-brain-line text-[#E8531A] text-sm"></i>
          </div>
          <div>
            <span className="text-white text-sm font-semibold">AI 智能分析</span>
            <span className="ml-2 text-xs text-white/40">基于全量用户数据实时分析</span>
          </div>
          <span className="flex items-center gap-1 text-xs text-green-400 bg-green-400/10 px-2 py-0.5 rounded-full">
            <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse inline-block"></span>
            实时运行中
          </span>
        </div>
        <div className="flex items-center gap-2">
          {reportReady ? (
            <button className="flex items-center gap-1.5 text-xs text-green-400 border border-green-400/30 px-3 py-1.5 rounded-lg cursor-pointer whitespace-nowrap hover:bg-green-400/10">
              <i className="ri-download-line"></i>下载AI报告
            </button>
          ) : (
            <button
              onClick={handleGenReport}
              disabled={generating}
              className="flex items-center gap-1.5 text-xs text-[#E8531A] border border-[#E8531A]/30 px-3 py-1.5 rounded-lg cursor-pointer whitespace-nowrap hover:bg-[#E8531A]/10 disabled:opacity-60"
            >
              {generating ? (
                <><i className="ri-loader-4-line animate-spin"></i>生成中...</>
              ) : (
                <><i className="ri-file-chart-line"></i>生成AI报告</>
              )}
            </button>
          )}
          <button
            onClick={() => setExpanded(!expanded)}
            className="text-xs text-white/50 hover:text-white/80 cursor-pointer whitespace-nowrap"
          >
            {expanded ? "收起" : "展开全部"}
          </button>
        </div>
      </div>

      <div className={`grid grid-cols-4 gap-3 ${!expanded ? "" : ""}`}>
        {insights.map(item => (
          <div key={item.id} className={`${item.bg} ${item.border} border rounded-xl p-3`}>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-1.5">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${item.icon} ${item.color} text-sm`}></i>
                </div>
                <span className="text-xs font-semibold text-gray-800">{item.title}</span>
              </div>
              <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium ${item.tagColor}`}>{item.tag}</span>
            </div>
            <p className="text-xs text-gray-600 leading-relaxed mb-2" dangerouslySetInnerHTML={{ __html: item.desc }}></p>
            <button className={`text-xs ${item.color} font-medium cursor-pointer hover:underline whitespace-nowrap`}>
              {item.action} <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
